export default __webpack_public_path__ + "static/media/bell-icon.83fd2fc6.svg";